import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ErrorBoundary from './ErrorBoundary.jsx'
import HomeScreen from '../HomeScreen.jsx';
import AnalyzeMap from '../intro/AnalyzeMap.jsx';
import Stage0 from '../stage0/Stage0.jsx';
import Stage1 from '../stage1/Stage1.jsx';
import Stage1Plant from '../stage1Plant/Stage1Plant.jsx';
import Stage2 from '../stage2/Stage2.jsx';
// import Stage3 from '../Stage-3/Stage3.jsx';
// import Stage4 from '../Stage-4/Stage4.jsx';
// import Stage5 from '../Stage-5/Stage5.jsx';
// import Stage6 from '../Stage-6/Stage6.jsx';
// import Stage7 from '../Stage-7/Stage7.jsx';
// import Stage8 from '../Stage-8/Stage8.jsx';
// import Stage9 from '../Stage-9/Stage9.jsx';
// import Stage10 from '../Stage-10/Stage10.jsx';

// import Classroom from '../Stage-2/Classroom.jsx';

export default function MainNav() {
    return (
        <ErrorBoundary>
            <Routes>
                <Route path="/" element={<HomeScreen />} />
                <Route path="/analyzeMap" element={<AnalyzeMap/>} />
                <Route path="/Stage1-Plant" element={<Stage1Plant />} />
                <Route path="/Stage0" element={ <Stage0/> } />
                <Route path="/Stage1" element={ <Stage1/> } />
                <Route path="/Stage2" element={ <Stage2/> } />
                {/*     <Route path="/Classroom" element={ <Classroom/> } />
                <Route path="/Stage3" element={ <Stage3/> } />
                <Route path="/Stage4" element={ <Stage4/> } />
                <Route path="/Stage5" element={ <Stage5/> } />
                <Route path="/Stage6" element={ <Stage6/> } />
                <Route path="/Stage7" element={ <Stage7/> } />
                <Route path="/Stage8" element={ <Stage8/> } />
                <Route path="/Stage9" element={ <Stage9/> } />
                <Route path="/Stage10" element={ <Stage10/> } /> */}
            </Routes>
        </ErrorBoundary>
    );
}
